<template>
    <b-card no-body class="mb-0">
      <b-row class="p-2 pt-3 pb-3">
        <b-col cols :md=4>
          <h5><strong>Step 1:</strong> Select data source</h5>
          <b-form-select
            v-model="database_"
            :options="databases"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            >
          </b-form-select>
        </b-col>
        <b-col v-if="database_ != null" cols :md=4>
          <h5><strong>Step 2:</strong> Select data collection to view</h5>
          <b-form-select
            v-model="collection_"
            :options="collections"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            >
          </b-form-select>
        </b-col>
      </b-row>

      <b-tabs v-if="raw_file != null" card nav-class="pt-3 pl-2" class="tabs" v-model="tab" :key="raw_file['_id']">

          <b-row>
            <b-col :cols="2"></b-col>
            <b-col :cols="8" class="text-center">
              <div class="px-3">
                <div class="h4 m-0 p-0">
                  <i v-if="collection_count == null" class="fa fa-spinner fa-spin"/>
                  <count-to v-else :start-val="0" :end-val="collection_count" :duration="2000"/>
                </div>
                <div>{{raw_file['originalName'].replace("_", " ").toUpperCase()}}</div>
              </div>
            </b-col>
            <b-col :cols="2"></b-col>
          </b-row>

          <conditional-tab :status="true" class="m-2">
            <insights
              :segment-i-d="segmentID"
              :raw-file="raw_file"
              :data-type="raw_file['originalName']"
              :database="raw_file['database']"
              :active="true" />
          </conditional-tab>

      </b-tabs>
    </b-card>
</template>

<script>
  import LoansTab from './LoansTab';
  import DynamicRules from './DynamicRules';
  import ConditionalTab from './ConditionalTab';
  import CustomersTab from './CustomersTab';
  import TransactionsTab from './TransactionsTab';
  import ConditionalSection from './ConditionalSection';
  import FilterInput from './FilterInput';
  import Insights from "./Insights";
  import KeyInsights from "./KeyInsights";
  import ObjectHash from "object-hash";
  import {fetchInsight} from './utils';



  export default {
    name: 'InsightsSection',

    components: {
      LoansTab,
      DynamicRules,
      ConditionalTab,
      Insights,

      CustomersTab,
      TransactionsTab,
      ConditionalSection,
      FilterInput,
      KeyInsights
    },

    props: {
      segmentID: String
    },


    data() {
      console.log("Files: ", this.$store.state.files);
      const C = this.$store.state.files.collections;
      const KI = this.$store.state.files.keyInsightIds;
      const F = this.$store.state.files.fileList;
      return {
        tab: 0,
        dataStatus: C.reduce((m, k) => ({...m, [k]: null}), {}),
        kiDataStatus: KI.reduce((m, k) => ({...m, [k]: null}), {}),
        C: C,
        F: F,
        KI: KI,
        database_: null,
        collection_: null,
        raw_file: null,
        collection_count: null,
        idList: [],
        kiCount: KI.length,
        filter: {
          method: "dynamic",
          values: {
            filters: [],
            logic: "and"
          }
        }
      };

    },

    computed: {
      collections(){
        //  return this.$store.state.files.collections;
        var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          var col_name = this.getCollection(file);
          if (file.database === this.database_ && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },

      databases() {
        var databases = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.database && !databases.includes(file.database)) {
            databases.push(file.database);
          }
        });
        return databases;
      },

      raw_files() {
        // let keyIs = {'database': null, 'originalName': 'key insights'};
        // return [keyIs].concat(this.F);
        this.F.forEach(x => {
          this.idList.push(x['id']);
        });
        return this.F;
      },
    
      hash() {
        ObjectHash(this.filter);
      }
    },

    watch: {
      collection_: function(val) {
        if (!!val) {
          this.$store.state.files.fileList.forEach(file => {
          // var col_name = this.getCollection(file);
          if (file.database === this.database_ && file.originalName === this.collection_) {
              this.raw_file = file;
              this.getCount();
            }
          });
        }
      }
    },

    methods: {
      isActive(f) {
        const index = () => {
          if (key === "customers") return 0;
          if (key === "transactions") return 1;
          if (this.fileExists("transactions")) return 2;
          return 1;
        };

        return this.idList.indexOf(f) === this.tab;
      },

      getCollection(file) {
        if (!!file.originalName) {
          if (file.originalName.indexOf(".csv") > -1) {
            return file._id;
          }
        }
        return file.originalName;
      },

      getCount() {
        this.collection_count = null;
        fetchInsight(`Count`, {...this.filter, collection: this.getCollection(this.raw_file), database: this.database_})
          .then(value => {
            this.collection_count = value;
          });
        // return this.collection_count;
      }
    },
  };
</script>

<style scoped>

</style>
